export default "__VITE_ASSET__8371717d__"